import { HeaderContainer } from './header.styles';
import { ReactComponent as UserProfileIcon } from "../../assets/svgs/icons/userProfile-icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/svgs/icons/logout-icon.svg";
import { Button, Col, Dropdown, MenuProps, Row, Space, Tooltip, message } from 'antd';
import { IconButton, Menu, MenuItem } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getCurrentUserEmail, logOutUser } from '../userManager/userManagementUtils';
import { Store } from '../../store/Store';
import { ReactComponent as ArrowTopIcon } from "../../assets/svgs/icons/arrow-top-icon.svg";
import { ReactComponent as ArrowDownIcon } from "../../assets/svgs/icons/arrow-down-icon.svg";
import { ReactComponent as PaymentIcon } from "../../assets/svgs/icons/payment-icon.svg";
import { ReactComponent as SupportIcon } from "../../assets/svgs/icons/support-icon.svg";
import { ReactComponent as ShareIcon } from "../../assets/svgs/icons/share-icon.svg";
import { DashboardOutlined } from '@ant-design/icons';
import { ReactComponent as TransactionIcon } from "../../assets/svgs/icons/transaction-icon.svg";
import { ReactComponent as UserGuidIcon } from "../../assets/svgs/icons/user-guide.svg";
import * as THREE from "three";
import AOIHeaderMenu from './AOIHeaderMenu';
import ToolsHeaderMenu from './ToolsHeaderMenu';
import AoiSaveModal from '../modal/AoiSaveModal';
import { AOIAddState } from '../../types/interfaces';
import DownloadHeaderMenu from './DownloadHeaderMenu';
import { useNavigate } from 'react-router-dom';
import CustomMessage from '../common/CustomMessage';
import ShareDataModal from '../tables/user/share/ShareDataModal';

const Header = () => {
    const [openUserMenu, setOpenUserMenu] = React.useState<null | HTMLElement>(null);
    const [showHeader, setShowHeader] = useState<boolean>(true);
    const [showShareTable, setShowShareTable] = useState<boolean>(false);
    const [userEmail, setUserEmail] = useState<string>('');
    const [aoiAddState, setAoiAddState] = useState<null | AOIAddState>(null);
    const [showMessage, setShowMessage] = useState<boolean>(false);
    const navigate = useNavigate();


    useEffect(() => {
        getCurrentUserEmail().then((res) => {
            if(res) {
                setUserEmail(res as string);
            }
        }).catch((err) => {
            console.log(err);
        });
    }, []);

    const settings = [
        {
            "name": "Logout",
            "icon": <LogoutIcon key="LogoutIcon" title="Logout" color='#ffffff' />,
            "onClick": () => {
                logOutUser().then((res) => {
                    message.success(res as string);
                    Store.isLoggedIn = false;
                    navigate('/login')
                }).catch((err) => {
                    console.log(err);
                })
            }
        },
        {
            "name": "Quotas",
            "icon": <DashboardOutlined key="QuotasIcon" title="Quotas" color='#ffffff' />,
            "onClick": () => {
                navigate('/quotas')
            }
        },
        {
            "name": "Transaction Logs",
            "icon": <TransactionIcon key="TransactionIcon" title="Transaction Log" color='#ffffff' />,
            "onClick": () => {
                navigate('/transactions')
            }
        },
        {
            "name": "Payment",
            "icon": <PaymentIcon key="PaymentIcon" title="Payment" color='#ffffff' />,
            "onClick": () => {
                navigate('/billing')
            }
        },
        {
            "name": "Support",
            "icon": <SupportIcon key="SupportIcon" title="Support" color='#ffffff' />,
            "onClick": () => {
                navigate('/support')
            }
        },
        {
            "name": "Share",
            "icon": <ShareIcon key="ShareIcon" title="Share" color='#ffffff' />,
            "onClick": () => {
                setShowShareTable(true)
            }
        },
    ];

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setOpenUserMenu(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        setOpenUserMenu(null);
    };

    const handleMenuItemClick = (itemName: string) => {
        let tool = settings.find((item) => item.name === itemName);
        tool?.onClick();
        handleCloseUserMenu();
    };


    const initAddingAOI = (isQuickDownload : boolean) => {
        setShowMessage(true);
        const domElement = window.potreeViewer.renderer.domElement;
        const insertionCallback = (e1: any) => {
            if (e1.button === THREE.MOUSE.RIGHT && window.measurement) {
                domElement.removeEventListener("mouseup", insertionCallback, true);
                setAoiAddState({
                    isQuickDownload: isQuickDownload,
                });
            }
        };
        domElement.addEventListener("mouseup", insertionCallback, true);

        const measurement = window.measuringTool.startInsertion({
            showDistances: true,
            showArea: true,
            closed: true,
            name: "Area"
        });
        window.potreeSidebar.selectNode(measurement.uuid);
        window.measurement = measurement;
    }

    return (
        <HeaderContainer>
            {showHeader && (
                <div className="header__block">
                    <Row gutter={[16, 16]} className='project_input_row'>
                        <Col xs={16} sm={16} md={16} lg={20} xl={20} className='menu_left_column'>
                            <div className='menu_top_box'>
                                <AOIHeaderMenu initAddingAOI={initAddingAOI} />
                                <ToolsHeaderMenu />
                                <DownloadHeaderMenu initAddingAOI={initAddingAOI}/>
                            </div>
                        </Col>
                        <Col xs={8} sm={8} md={8} lg={4} xl={4} className='project_input_column'>
                            <div className='profile_main_block'>
                                <div className='user_guide_box'>
                                    <Tooltip placement='left' title="User guide" >
                                        <UserGuidIcon key="UserGuidIcon" className='menu_icon profile__icon'
                                            onClick={() => {
                                                window.open("https://adv-algos.notion.site/2303cee9a5ea46f5b6f0b38ee1f3e3b2?v=485ba19c087048b7b428bb9b7570c2d0", "_blank");
                                            }}
                                        />
                                    </Tooltip>
                                </div>
                                <div className='profile__box'>
                                    <Tooltip placement='left' title="User Profile" >
                                        <IconButton onClick={handleOpenUserMenu} className='header__btn'>
                                            <UserProfileIcon className="profile__icon" key="UserProfileIcon" title="User Profile" color='#ffffff' />
                                        </IconButton>
                                    </Tooltip>
                                    <Menu
                                        sx={{
                                            mt: '35px',
                                            '& .MuiList-root li': {
                                                color: '#ffffff',
                                                fontSize: '14px',
                                                borderBottom: "1px solid #6A727C",
                                                padding: "10px 15px"
                                            },
                                            '& .MuiList-root li:last-child': {
                                                borderBottom: "none",
                                            },
                                            '& ul': {
                                                padding: "0px",
                                            },
                                            '& .MuiList-root li svg': {
                                                width: "24px",
                                                height: "24px"
                                            },
                                            '& .MuiList-root li:hover': {
                                                '& .menu_title': {
                                                    color: "#36BDBE !important",
                                                },
                                                '& svg path': {
                                                    stroke: "#36BDBE",
                                                },
                                                '& svg': {
                                                    color: "#36BDBE",
                                                }
                                            },
                                            '& .MuiPaper-root': {
                                                backgroundColor: '#33363C',
                                                borderRadius: "8px",
                                                left: "auto !important",
                                                right: "10px"
                                            },
                                        }}
                                        id="menu-appbar"
                                        anchorEl={openUserMenu}
                                        anchorOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        }}
                                        open={Boolean(openUserMenu)}
                                        onClose={() => handleCloseUserMenu()}
                                        className='menu__user__box'
                                    >
                                        <div className="email_text">
                                            {userEmail}
                                        </div>
                                        {settings.map((item) => (
                                            <MenuItem key={item.name} onClick={() => handleMenuItemClick(item.name)}>
                                                <div style={{ display: "flex",width:"100%", alignItems: "center", gap: "10px" }}>
                                                    {item.icon}
                                                    <p className="menu_title" style={{ color: "#ffffff", fontSize: "15px", margin: "0px" }}>{item.name}</p>
                                                </div>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            )}

            {showMessage && (
                <CustomMessage
                    content="Left click to select points. Right click when finished."
                    duration={5}
                    onClose={() => setShowMessage(false)}
                />
            )}

            <div className="header_toggle_box" style={{ top: showHeader ? "50px" : "0" }} onClick={() => setShowHeader(!showHeader)}>
                {showHeader ? (
                    <ArrowTopIcon key="ArrowTopIcon" title="Hide" color='#ffffff' />
                ) : (
                    <ArrowDownIcon key="ArrowDownIcon" title="Show" color='#ffffff' />
                )}
            </div>
            {showShareTable && <ShareDataModal setShow={setShowShareTable} />}

            <div style={{
                position: 'absolute',
                left: "0px"

            }}>
                {aoiAddState && (
                    <AoiSaveModal
                        onCancel={() => {
                            setAoiAddState(null);
                            window.potreeViewer.scene.removeAllMeasurements();
                        }}
                        setAoiAddState={setAoiAddState}
                        aoiAddState={aoiAddState}
                    />
                )}
                {
                    showShareTable && (
                        <ShareDataModal setShow={setShowShareTable} />
                    )
                }
            </div>
        </HeaderContainer>

    );
}

export default Header;
